const {
  adminUrl,
  ajaxUrl,
  restUrl,
  backgroundIframeUrl,
  deviceId,
  didDisconnect,
  env,
  formsScript,
  formsScriptPayload,
  hublet,
  hubspotBaseUrl,
  impactLink,
  leadinPluginVersion,
  loginUrl,
  pluginPath,
  ajaxNonce,
  restNonce,
  redirectNonce,
  plugins,
  phpVersion,
  portalId,
  portalEmail,
  iframeUrl,
  accountName,
  routes,
  theme,
  wpVersion,
  portalDomain,
  leadinQueryParamsKeys,
  oauth,
} = window.leadinConfig;

const i18n = window.leadinI18n;

export {
  adminUrl,
  ajaxUrl,
  restUrl,
  backgroundIframeUrl,
  deviceId,
  didDisconnect,
  env,
  formsScript,
  formsScriptPayload,
  hublet,
  hubspotBaseUrl,
  i18n,
  impactLink,
  leadinPluginVersion,
  loginUrl,
  pluginPath,
  ajaxNonce,
  restNonce,
  redirectNonce,
  plugins,
  phpVersion,
  portalId,
  portalEmail,
  iframeUrl,
  accountName,
  routes,
  theme,
  wpVersion,
  portalDomain,
  leadinQueryParamsKeys,
  oauth,
};
